import React from 'react';
import { Box, Typography, Grid, Card, CardContent } from '@mui/material';
const empresas = [
    {
        nombre: 'Barrera Romo',
        descripcion: 'Gestión financiera y fiscal',
        logo: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1749054155/ebm/EBM_logo_contorno_1_qvkicf.png',
        url: 'https://barreraromo.com.mx/'
    },
    {
        nombre: 'Legal Empresarial',
        descripcion: 'Legal Empresarial',
        logo: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1749225180/ebm/LOGOTIPO_LEGAFIRM_contorno_1_1_kxnrl7.png',
        ajustar: true,
        reducir: true,
        url: 'https://legafirm.com.mx/'
    },
    {
        nombre: 'Business Center School',
        descripcion: 'Escuela de Negocios',
        logo: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1749054158/ebm/LOGO_BR_Business_contorno_1_ssjeyv.png',
        url: 'https://brbusiness.com.mx/'
    },
    {
        nombre: 'Go can go',
        descripcion: 'Desarrollo Organizacional y Humano',
        logo: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1749054159/ebm/Logotipo_Go_can_go_2022_contorno_blanco_1_gcbjxh.png',
        url: 'https://gocango.com.mx/'
    },
    {
        nombre: 'Treedi',
        descripcion: 'Marketing y Publicidad',
        logo: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1749054160/ebm/LOGO_TREEDI_contorno_blanco_1_zpa159.png',
        reducir: true,
        url: 'https://treedi.com.mx/'
    },
    {
        nombre: 'gtdi',
        descripcion: 'Desarrollo de Sistemas',
        logo: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1749054161/ebm/Logo_GDTI_2022_contorno_1_m6dt9m.png',
        url: 'https://desarrollosgdti.com.mx/'
    },
];

export default function ConsorcioSection() {
    return (
        <Box
            sx={{
                px: 4,
                pt: 10,
                pb: 15.9,
                backgroundImage: 'url(https://res.cloudinary.com/dhoyyqszi/image/upload/v1749053994/ebm/room-used-official-event_1_1_uz4tmn.png)',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                color: 'white'
            }}
        >
            <Box sx={{ textAlign: 'center', mb: 4 }}>
                <img
                    src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1749054066/ebm/LOGO_BR_Contorno_1_kpstfq.png"
                    alt="BR Consultores"
                    style={{ maxWidth: 100, marginBottom: -15, marginTop: 60 }}
                />
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                    <Box
                        component="img"
                        src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1749057676/ebm/Group_1000004267_qoxefs.png"
                        alt="Somos un consorcio"
                        sx={{
                            maxWidth: 400,
                            width: '100%',
                            margin: '50px auto 32px auto',
                            display: 'block'
                        }}
                    />
                </Box>
            </Box>

            <Grid container spacing={2} justifyContent="center" sx={{ mt: 8 }}>
                {empresas.map((empresa, index) => (
                    <Grid item xs={6} sm={4} md={2} key={index}>
                        <Card
                            onClick={() => window.open(empresa.url, '_blank')}
                            sx={{
                                width: '180px',
                                height: '180px',
                                backgroundColor: 'rgba(0,0,0,0.4)',
                                color: 'white',
                                borderRadius: '16px',
                                border: '1px solid #00C3F0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mx: 'auto',
                                transition: 'all 0.3s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-5px)',
                                    boxShadow: '0 4px 20px rgba(0, 195, 240, 0.5)',
                                    cursor: 'pointer'
                                },
                                overflow: 'hidden'
                            }}
                        >
                            <CardContent sx={{
                                p: 0,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative'
                            }}>
                                <Box
                                    component="img"
                                    src={empresa.logo}
                                    alt={empresa.nombre}
                                    sx={{
                                        width: empresa.reducir ? '50%' : empresa.ajustar ? '65%' : '75%',
                                        height: empresa.reducir ? '50%' : empresa.ajustar ? '65%' : '75%',
                                        objectFit: 'contain',
                                        display: 'block',
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)'
                                    }}
                                />
                            </CardContent>
                        </Card>
                        <Box sx={{ textAlign: 'center', mt: 2 }}>
                            <Box sx={{
                                width: '150px',
                                height: '2px',
                                backgroundColor: '#D4A76A',
                                mx: 'auto',
                                mb: 1
                            }} />
                            <Typography variant="caption" sx={{
                                fontSize: '0.75rem',
                                display: 'block',
                                mt: 0.5
                            }}>
                                {empresa.descripcion}
                            </Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}